<app-payer-header
  *ngIf="currentMerchant"
  [merchantName]="currentMerchant.name"
  [merchantLogoUrl]="currentMerchant.strictly?.logoUrl || null"
></app-payer-header>

<div class="full-page-state">
  <span *ngIf="!currentMerchant" class="brand-mark" aria-hidden="true">P</span>

  <span class="full-page-state-icon" aria-hidden="true">
    <svg class="icon icon-lg" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="8" x2="12" y2="13" />
      <line x1="12" y1="16" x2="12" y2="16.01" />
    </svg>
  </span>

  <span class="full-page-state-code" *ngIf="errorCode">Error {{ errorCode }}</span>

  <h1 class="full-page-state-title">{{ messageError }}</h1>
  <p class="full-page-state-body">
    The link may be incomplete or the page may have moved. Check the URL in
    the message you received.
  </p>

  <div class="full-page-state-actions">
    <!-- Payer-context errors go back to that merchant's payment page, not
         the admin/QuickBooks area — keeps the payer/admin separation clean. -->
    <a
      *ngIf="currentMerchant"
      [routerLink]="['/merchant', currentMerchant.paymentLink]"
      class="btn btn-primary btn-lg"
      >Back to invoice</a
    >
    <a *ngIf="!currentMerchant" routerLink="/quickbooks" class="btn btn-primary btn-lg">Go back</a>
    <a href="mailto:intuit@solvisse.com" class="btn btn-secondary btn-lg">Contact support</a>
  </div>

  <div class="payer-secure-badge-row" *ngIf="currentMerchant">
    <span class="payer-secure-badge">
      <svg class="icon icon-sm" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
      Secure payment
    </span>
  </div>
</div>
